import { NgModule } from '@angular/core';
import { QtNetworkErrorComponent } from './components';
import { HealthcheckCoreService } from './services/healthcheck-core.service';

@NgModule({
  imports: [QtNetworkErrorComponent],
  exports: [QtNetworkErrorComponent],
  providers: [HealthcheckCoreService],
})
export class HealthcheckCoreModule {}
